import React, { Fragment, useRef, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";
import { Menu, Popover, Transition } from "@headlessui/react";
import { BellIcon, MenuIcon, XIcon } from "@heroicons/react/outline";
import { confirmAlert } from "react-confirm-alert";
import { BASE_IMAGES_URL, APP_API_KEY } from "@constant";
import { logout, setLocaleLanguage } from "@mainaction";
import { classNames } from "@basecomponent";
import LocaleStrings from "@language";
import { CopyToClipboard } from "react-copy-to-clipboard";
import moment from "moment";
const user = {
  name: "Memory Quiz",
  email: "memoryquiz@example.com",
  imageUrl:
    "https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
};

const userNavigation = [
  { key: "profile", name: LocaleStrings.profile },
  { key: "logout", name: LocaleStrings.logout },
];

const Header = (props) => {
  const buttonRef = useRef();
  let {
    routes,
    session,
    eventData,
    localeLanguage,
    myBalance,
    conversionRate,
  } = props;
  const location = useLocation();
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);
  //console.log("localeLanguage", localeLanguage);
  const handleActions = (item) => {
    if (item?.key === "logout") {
      confirmAlert({
        title: LocaleStrings.logout_confirmation_title,
        message: LocaleStrings.logout_confirmation_text,
        buttons: [
          {
            label: LocaleStrings.button_yes,
            onClick: () => {
              props.logout(session);
              setTimeout(() => {
                navigate("/auth/login");
              }, 500);
            },
          },
          {
            label: LocaleStrings.button_no,
            onClick: () => {},
          },
        ],
      });
    } else if (item?.key === "profile") {
    }
  };

  // creates the links that appear in the left menu
  const createLinks = () => {
    var routesNew = _.filter(routes, function (list) {
      return (
        list.display &&
        list.layout === "/admin" &&
        (list.section === "both" || list.section === session?.usertype)
      );
    }); // custom check is login not display in sidebar

    return routesNew.map((item, key) => {
      var selected = _.includes(location.pathname, item.path);
      //console.log("path", item.path);
      return (
        <a
          key={item.name}
          href={`#${item.path}`}
          onClick={() => buttonRef.current?.click()}
          aria-current={selected ? "page" : undefined}
          className={classNames(
            selected ? "bg-gray-100 text-gray-900" : "hover:bg-gray-50",
            "block rounded-md py-2 px-3 text-base font-medium"
          )}
        >
          {item.name}
        </a>
      );
    });
  };

  const copyUrl = () => {
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 500);
  };

  const languageSet = (e) => {
    let lang = e.target.value;
    //console.log({ lang });
    props.setLocaleLanguage(lang);
  };

  var languages = [
    { value: "nl", text: "Nederlands" },
    { value: "fr", text: "English" },
  ];

  let tokenamount = 1;
  if (
    conversionRate &&
    conversionRate.length > 0 &&
    conversionRate[0]["tokenamount"]
  ) {
    tokenamount = conversionRate[0]["tokenamount"];
  }
  let years = 0;
  if (myBalance?.data?.length > 0) {
    years = moment(myBalance.data[0].validuntil).diff(moment(), "years", false);
  }

  return (
    <div>
      <Popover
        as="header"
        className={({ open }) =>
          classNames(
            open
              ? "bg-white lg:static lg:overflow-y-visible fixed inset-0 z-40 overflow-y-auto shadow-sm"
              : "",
            "shadow-sm lg:static lg:overflow-y-visible"
          )
        }
      >
        {({ open }) => (
          <>
            <div className="">
              <div className=" h-20 relative flex justify-between xl:grid xl:grid-cols-12 lg:gap-0 ">
                <div className="xl:col-span-2  bg-white border-b border-bottomborder flex justify-center items-center">
                  {eventData?.companylogo ? (
                    <div className="flex justify-center items-center">
                      <div className="pr-1">
                        <img
                          src={`${BASE_IMAGES_URL}/carwashowner/${eventData?.companylogo}?api_key=${APP_API_KEY}`}
                          className="object-contain h-14"
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="flex items-center  md:absolute md:right-0 md:inset-y-0 lg:hidden">
                  {/* Mobile menu button */}
                  <Popover.Button
                    ref={buttonRef}
                    className="-mx-2 rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-rose-500"
                  >
                    <span className="sr-only">Open menu</span>
                    {open ? (
                      <XIcon className="block h-6 w-6" aria-hidden="true" />
                    ) : (
                      <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                    )}
                  </Popover.Button>
                </div>
                <div className="hidden lg:flex lg:items-center lg:justify-between xl:col-span-10 bg-theme p-0 sm:px-6">
                  <div className="text-white cursor-pointer text-lg font-medium">
                    <div>
                      {LocaleStrings.welcome} {session.username}
                    </div>
                    <div className="flex items-center text-sm">
                      {LocaleStrings.userid}:-{session.userid}&nbsp;&nbsp;&nbsp;
                      <CopyToClipboard
                        text={session.userid}
                        onCopy={() => copyUrl()}
                      >
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            stroke-width="2"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
                            />
                          </svg>
                        </span>
                      </CopyToClipboard>
                      {copied ? (
                        <span className="text-sm text-red-600">Copied.</span>
                      ) : null}
                    </div>
                  </div>
                  <div className="flex items-center">
                    <div className="mr-4">
                      <select
                        className="input-field common-field"
                        onChange={(e) => languageSet(e)}
                      >
                        {languages.map((object, index) => {
                          return (
                            <option
                              key={`${object.value}-${index}`}
                              value={object.value}
                              selected={
                                localeLanguage == object.value ? "selected" : ""
                              }
                            >
                              {object.text}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div
                      className="text-white font-medium cursor-pointer"
                      onClick={() =>
                        handleActions({
                          key: "logout",
                          name: LocaleStrings.logout,
                        })
                      }
                    >
                      {LocaleStrings.logout}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Popover.Panel
              as="nav"
              className="lg:hidden bg-gray-100 z-50 shadow-2xl  h-full"
              aria-label="Global"
            >
              <div className="max-w-3xl mx-auto flex items-center justify-start font-bold border-b px-4 pt-2 pb-3">
                {eventData?.companyname}
              </div>
              {myBalance?.data?.length > 0 ? (
                <div className="max-w-3xl mx-auto px-4 pt-2 pb-3">
                  <div className="text-base">
                    {LocaleStrings.balance_text}: &nbsp;&euro;
                    {(myBalance.data[0].totaltoken * tokenamount).toFixed(2)}
                  </div>
                  {years < 20 ? (
                    <div className="text-xs">
                      {LocaleStrings.valid_until}{" "}
                      {moment(myBalance.data[0].validuntil).format(
                        "DD-MM-YYYY"
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                ""
              )}
              <div className="max-w-3xl mx-auto px-2 pt-2 pb-3 space-y-1 sm:px-4">
                {createLinks()}
              </div>
              <div className="border-t border-gray-200 pt-4">
                <div className="max-w-3xl mx-auto px-4 flex items-center sm:px-6">
                  <div className="ml-3">
                    <div className="text-base font-medium text-gray-800">
                      {session.username}
                    </div>
                    <div className="text-sm font-medium text-gray-500">
                      {session.email}
                    </div>
                  </div>
                </div>
                <div className="mt-3 max-w-3xl mx-auto px-2 space-y-1 sm:px-4">
                  {userNavigation.map((item) => (
                    <span
                      key={item.key}
                      onClick={() => handleActions(item)}
                      className="cursor-pointer block rounded-md py-2 px-3 text-base font-medium text-gray-500 hover:bg-gray-50 hover:text-gray-900"
                    >
                      {item.name}
                    </span>
                  ))}
                </div>
              </div>
            </Popover.Panel>
          </>
        )}
      </Popover>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    session: state.session,
    eventData: state.eventData,
    localeLanguage: state.localeLanguage,
    myBalance: state.myBalance,
    conversionRate: state.conversionRate.data,
    localeLanguage: state.localeLanguage,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ logout, setLocaleLanguage }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Header);
